import { render } from "./lightboxtwo.vue?vue&type=template&id=59192375"
import script from "./lightboxtwo.vue?vue&type=script&lang=js"
export * from "./lightboxtwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__